import { IState } from "../State/State";
import { ModelItem } from "../itemTypes";

export class Retriever<T extends ModelItem> {

    async activate(state: IState<T>): Promise<any> {}
    deactivate(): void {}
    async setParams(...params: any[]): Promise<any> {}
    onPanelEnter(): void {}
    onPanelLeave(): void {}
}